"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.flightPassengerColumns = void 0;
const selectColumn_1 = require("../../../Table/columns/selectColumn");
const actionsColumn_1 = require("./actionsColumn");
const Comment_1 = require("./Column/Comment");
const FirstName_1 = require("./Column/FirstName");
const Flights_1 = require("./Column/Flights");
const LastName_1 = require("./Column/LastName");
const Notified_1 = require("./Column/Notified");
const Phone_1 = require("./Column/Phone");
const Price_1 = require("./Column/Price");
const Reservator_1 = require("./Column/Reservator");
const Seat_1 = require("./Column/Seat");
const flightPassengerColumns = (config) => ([
    (0, selectColumn_1.selectColumn)(),
    (0, LastName_1.ColumnLastName)(),
    (0, FirstName_1.ColumnFistName)(),
    (0, Seat_1.ColumnSeat)({
        onSeatClick: config.seat.select,
        disabled: config.seat.disabled,
    }),
    (0, Price_1.ColumnPrice)({
        onPassengersCountClick: config.price.countClick,
    }),
    (0, Flights_1.ColumnFlights)({ flight: { id: config.flights.flightId } }),
    (0, Phone_1.ColumnPhone)(),
    (0, Notified_1.ColumnNotified)({
        onChange: config.notified.change,
        disabled: config.notified.disabled,
        hidden: config.notified.hidden,
    }),
    (0, Reservator_1.ColumnReservator)(),
    (0, Comment_1.ColumnComment)(),
    (0, actionsColumn_1.flightPassengerActionsColumn)(config.actions),
]);
exports.flightPassengerColumns = flightPassengerColumns;
//# sourceMappingURL=tableColumns.js.map